import React, { useContext } from 'react';
import styled from 'styled-components';
import { appStore } from 'store/app';

let isMTA = false;
if (window.CB && window.CB.isMTA) {
  isMTA = true;
}

const Component = () => {
  const [appState] = useContext(appStore);
  return (
    <Container>
      <BottleImage src={appState.customData.bottle.image} />
      {appState.customData.partsList.map((item, index) => {
        // アイテムのレイヤー画像から、ボトルサイズに合わせたものを抽出
        const image = item.composite_images[appState.customData.bottle.size];
        return <LayerImage key={index} src={image} />;
      })}
      {isMTA && appState.customData.bootsList.map((item, index) => {
        // アイテムのレイヤー画像から、ボトルサイズに合わせたものを抽出
        const bootImg = item.variants[appState.customData.bottle.size].image;
        return <LayerImage key={index} src={bootImg} />;
      })}
    </Container>
  );
};

export default Component;

const Container = styled.div`
  position: relative;
  padding-top: 100%;
`;

const BottleImage = styled.img`
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const LayerImage = styled.img`
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

